import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { DropdownItem, Dropdown } from '@comparethemarketau/manor-dropdown';
import { connect } from 'react-redux';

import { StyledManorDropdown } from './styled_manor_dropdown';
import { coverTypeStateMapping, coverTypeDispatchMapping } from './filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    defaultDropdown: {
        height: theme.spacing[48]
    }
}));

const _CoverTypeFilterDropdown = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { stagedValue, stageChange, useDefaultManorDropdown } = props;
    const handleChange = (event, value, option) => {
        if (value === stagedValue) {
            return;
        }
        stageChange(value);
    };

    return (
        <div className={classNames('test-policyFilters-coverType')} data-value={stagedValue}>
            {
                useDefaultManorDropdown ? (
                    <Dropdown
                        id="filters-coverType-dropdown"
                        key={`coverType-filter-${stagedValue}`}
                        trackingLabel="Cover type Filter"
                        label={'Cover Type'}
                        selectedValue={stagedValue}
                        handleChange={handleChange}
                        tooltip={null}
                        className={classes.defaultDropdown}
                    >
                        <DropdownItem value={COVER_TYPE_COMPREHENSIVE}>Comprehensive</DropdownItem>
                        <DropdownItem value={COVER_TYPE_TPFT}>Third Party Fire and Theft</DropdownItem>
                        <DropdownItem value={COVER_TYPE_TPPD}>Third Party Property Damage</DropdownItem>
                    </Dropdown>
                ) : (
                    <StyledManorDropdown
                        id="filters-coverType-dropdown"
                        key={`coverType-filter-${stagedValue}`}
                        trackingLabel="Cover type Filter"
                        label={'COVER TYPE'}
                        variant="text"
                        selectedValue={stagedValue}
                        handleChange={handleChange}
                        tooltip={null}
                    >
                        <DropdownItem value={COVER_TYPE_COMPREHENSIVE}>Comprehensive</DropdownItem>
                        <DropdownItem value={COVER_TYPE_TPFT}>Third Party Fire and Theft</DropdownItem>
                        <DropdownItem value={COVER_TYPE_TPPD}>Third Party Property Damage</DropdownItem>
                    </StyledManorDropdown>
                )
            }
        </div>
    );
};

const COVER_TYPE_COMPREHENSIVE = 'COMPREHENSIVE';
const COVER_TYPE_TPFT = 'TPFT';
const COVER_TYPE_TPPD = 'TPPD';

_CoverTypeFilterDropdown.propTypes = {
    stagedValue: PropTypes.oneOf([COVER_TYPE_COMPREHENSIVE, COVER_TYPE_TPFT, COVER_TYPE_TPPD]),
    stageChange: PropTypes.func,
    /**
     * Different UI implement
     */
    useDefaultManorDropdown: PropTypes.bool
};

const CoverTypeFilterDropdown = connect(coverTypeStateMapping, coverTypeDispatchMapping)(_CoverTypeFilterDropdown);
export { CoverTypeFilterDropdown };
